import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar, Alert, CircularProgress, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'; // Import DataGrid
import { investorApi, vendorApi } from "../../api/api";


const TeamPage = () => {
  const [loading, setLoading] = useState(true);  // Track loading stat
  const [selectedImage, setSelectedImage] = useState('/logo192.png'); // Default local image URL
  const [rows, setRows] = React.useState([]); // Define the rows state
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleAction = (action, row) => {
    navigate(`/team/addTeam`); // Make sure this is the correct route for your details page

    if (action === "edit") {
      navigate(`/team/editTeam?id=${row.id}`,
        {
          state: {
            Id: row.id,
            MemberName: row.MemberName,
            description: row.description,
            Mobilenumber: row.Mobilenumber,
            IconUrl: row.ImageUrl,
            email: row.email,
            specialization: row.specialization,
            Status: row.Status

          }
        })
    }
  }
  useEffect(() => {
    const getTeamData = async () => {
      setLoading(true);  // Set loading to true initially
      try {
        const response = await investorApi.getLegalTeam();
        // Check if the response data is an array

        if (Array.isArray(response.data)) {
          setRows(response.data);  // Set data if it's an array
        } else {
          console.error('API response is not an array');
          setRows([]);  // Set an empty array if response is not as expected
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setRows([]);  // If error, set empty array
      } finally {
        setLoading(false);  // Stop loading after the fetch attempt (whether successful or not)
      }
    };
    getTeamData();
  }, []);


  const getStatusColor = (status) => {
    const colors = {
      'InProgress': 'red',
      'Rejected': 'blue',
      'Active': 'green'
    };
    return colors[status] || '#000000';
  };
  const formattedData = rows.map((item) => ({
    id: item.id,
    MemberName: item.name,
    description: item.description,
    specialization: item.specialization,
    ImageUrl: item.profile_path,
    Mobilenumber: item.contact_number,
    email: item.email,
    Status: item.status
  }));

  // console.log(formattedData);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this team member?"
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      await vendorApi.deleteLegalTeam(id);

      // Remove row from table
      setRows((prev) => prev.filter((row) => row.id !== id));

      // ✅ Success message
      setSnackbarMessage("Team member deleted successfully");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

    } catch (error) {
      console.error("Delete failed", error);

      // ❌ Error message
      setSnackbarMessage("Failed to delete team member");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);

    } finally {
      setLoading(false);
    }
  };


  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "MemberName",
      headerName: "Member Name",
      width: 200,
    },
    {
      field: "Mobilenumber",
      headerName: "Mobile Number",
      width: 200,
      renderCell: params => (
        <Typography sx={{ color: '#0871c5' }}>
          {params.value}
        </Typography>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      width: 250
    },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   width: 300,
    // },
    {
      field: "specialization",
      headerName: "specialization",
      width: 250,
    },
    {
      field: "Status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => (
        <div style={{ color: getStatusColor(params.value), fontWeight: 'bold' }}>
          {params.value}
        </div>
      )
    },

    // {
    //   field: "ImageUrl", // Display the image in the IconUrl field
    //   headerName: "Icon",
    //   width: 100,
    //   renderCell: (params) => (
    //     <img
    //       src={params.value} // Local image fallback
    //       alt="Project Icon"
    //       style={{ width: "50px", height: "50px", borderRadius: "5px", cursor: "pointer" }}
    //     />
    //   ),
    // },
    {
      field: "action",
      headerName: "Action",
      width: 180,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            size="small"
            variant="contained"
            onClick={() => handleAction("edit", params.row)}
          >
            Edit
          </Button>

          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={() => handleDelete(params.row.id)}
          >
            Delete
          </Button>
        </Box>
      ),
    },

  ];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
      <div style={{ width: '100%' }}>

        <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
          <Grid item>
            <h3 >Team</h3>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              style={{
                height: '40px',
              }}
              onClick={handleAction}
            >
              Add New
            </Button>
          </Grid>
        </Grid>

        <div style={{ height: 500, marginTop: "20px" }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CircularProgress />
            </Box>
          ) : (
            <DataGrid
              rows={formattedData}  // Use formatted data for display
              columns={columns}
              pageSize={20}
              disableSelectionOnClick
              autoHeight={false}
              sx={{
                height: 650,
                border: '1px solid #ccc',
                borderRadius: 2,
                fontSize: '0.9rem',
                backgroundColor: '#ffffff',
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f0f0f0ff',
                },
                '& .MuiDataGrid-cell': {
                  color: '#333',
                  borderBottom: '1px solid #ddd',
                },
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#f0f0f0ff',
                  color: 'black',
                  fontWeight: 'bold',
                },
                '& .MuiTablePagination-root': {
                  fontSize: '0.875rem',
                },
              }}
            />
          )}
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

    </Box>
  );
};

export default TeamPage;
